import Dexie from 'dexie';

export const OFFLINE_DB_NAME = 'oxygym-offline';

export const offlineDb = new Dexie(OFFLINE_DB_NAME);

offlineDb.version(1).stores({
  kv: 'key',
  outbox: 'id, status, createdAt, table',
});

export async function getKv(key) {
  try {
    const row = await offlineDb.kv.get(key);
    return row ? row.value : undefined;
  } catch {
    return undefined;
  }
}

export async function setKv(key, value) {
  try {
    await offlineDb.kv.put({ key, value, updatedAt: Date.now() });
  } catch {
    /* quota / private mode */
  }
}

export async function deleteKv(key) {
  try {
    await offlineDb.kv.delete(key);
  } catch {
    /* ignore */
  }
}

export async function deleteKvPrefix(prefix) {
  try {
    const rows = (await offlineDb.kv.toArray()).filter((row) => String(row.key || '').startsWith(prefix));
    if (!rows.length) return;
    await offlineDb.kv.bulkDelete(rows.map((row) => row.key));
  } catch {
    /* ignore */
  }
}

export async function getKvPrefix(prefix) {
  try {
    return (await offlineDb.kv.toArray()).filter((row) => String(row.key || '').startsWith(prefix));
  } catch {
    return [];
  }
}
